import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { withAdminAuthenticated, withAdminNotAuthenticated } from './auth';

import LoginScreen from './auth/Login';
import MainLayout from './shared/components/MainLayout';

const RouterComponent = () => (
  <Switch>
    <Route exact path='/login' component={withAdminNotAuthenticated(LoginScreen)} />
    <Route path="/" component={withAdminAuthenticated(MainLayout)} />
  </Switch>
);

export default RouterComponent;
